import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';
import GlowCard from './GlowCard';

interface KPITileProps {
  icon: LucideIcon;
  label: string;
  value: ReactNode;
  trend?: string;
  trendUp?: boolean;
  className?: string;
}

/** KPI stat tile — ported from the IQ Verity prototype. */
const KPITile = ({ icon: Icon, label, value, trend, trendUp, className = '' }: KPITileProps) => (
  <GlowCard className={`vr-kpi ${className}`.trim()}>
    <div className="vr-kpi-top">
      <div className="vr-kpi-icon">
        <Icon size={16} />
      </div>
      {trend && <span className={`vr-kpi-trend ${trendUp ? 'up' : 'down'}`}>{trend}</span>}
    </div>
    <p className="vr-kpi-value">{value}</p>
    <p className="vr-kpi-label">{label}</p>
  </GlowCard>
);

export default KPITile;
